import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import {
  getLoyaltyBenefitModalPath,
  LOYALTY_HOTEL_UPGRADE_HASH,
} from 'loyalty/constants/loyaltyRoutes'
import BodyText from 'LuxKit/Typography/BodyText'
import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
}

function LandingPageLoyaltyStayUpgrade(props: Props) {
  const { layout, benefitLabel } = props
  const intl = useIntl()
  const isInfinite = useAppSelector(getLoyaltyIsInfiniteAccountTier)

  const heading = isInfinite
    ? intl.formatMessage({
        id: 'o8mDr0BpCXuXwYSzqWHw',
        defaultMessage: 'Infinite room & package upgrades',
        description: 'Heading for the room and package upgrade benefit tile shown to Infinite tier members',
      })
    : intl.formatMessage({
        defaultMessage: 'Free room or package upgrades',
        id: '-jf0-fEIahxd0huyr3Zg',
        description: 'Heading for loyalty stay upgrade benefit tile component',
      })

  const infiniteSubtitle = (
    <BodyText variant="small">
      {intl.formatMessage({
        id: 'oxf3FGHL2rKnZ-RfCHPp',
        defaultMessage: 'For select hotel bookings',
        description: 'Subtitle for the Infinite room and package upgrade benefit tile on the loyalty account page',
      })}
    </BodyText>
  )

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="hotel_upgrade"
    heading={heading}
    subtitle={isInfinite ? infiniteSubtitle : benefitLabel}
    to={getLoyaltyBenefitModalPath(LOYALTY_HOTEL_UPGRADE_HASH)}
  />
}

export default LandingPageLoyaltyStayUpgrade
